<script>
import axios from "axios";
import moment from "moment";
export default {
  props: {
    documentos: Object,

    postDocumento: Function,

    documentoEditar: Object,
    files_old: Array,
    cancelar: Function,
  },
  data() {
    return {
      file: null,
      files: [],
      tipo_documento: 0,
      fecha_recepcion: "",

      idDocumento: "",
      //Archivos antiguos
      files_delete: [],

      ///BL
      statusBl: 0,

      //DIN
      fecha_aceptacion: "",
      tipo_inspeccion_aforo: "",

      //documento transporte
      tipo_transporte: 0,
      numero_documento: 0,

      //tipos vistos buenos
      tipo_vistos_buenos: 0,
      vb_n_solicitud: "",
      estado: undefined,
      //numero_guia_despacho
      numero_guia_despacho: "",

      //1er dus
      fecha_presentacion_primer_dus: "",
      hora_presentacion_primer_dus: "",
      numero_primer_dus: "",
      orden_alerta: "",

      //dus legalizado
      fecha_dus_legalizado: "",

      //OTRO
      nombre_documento: "",

      tipoDocumentoTransporte: "",
      tipoDocumentoVB: false,

      tipoDocumentoBl: false,

      numero_solicitud: undefined,

      tipos_inspeccion_aforo: [],

      errors: [],

      isFetching: undefined,
      isError: undefined,

      isOCRPending: undefined,
      isOCRrror: undefined,
    };
  },
  mounted() {
    this.files = this.files_old;
    this.setDocumentoEditar();
  },
  watch: {
    file: function (e) {
      this.$refs["file-input"].files.forEach((el) => {
        this.files.push(el);
      });
      this.$refs["file-input"].reset();
    },
    files_old: function (e) {
      this.files = this.files_old;
    },
    documentoEditar: function (e) {
      this.setDocumentoEditar();
    },
    tipo_documento: async function (newValue) {
      switch (newValue) {
        case 30:
        case 4:
          await this.fetchTiposInspeccion();
          break;
      }
    },
    isErrors: function (newValue) {
      if (newValue == true) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: this.errors.join("\n\n*"),
        });
      }
    },
  },
  methods: {
    setDocumentoEditar() {
      this.idDocumento = this.documentoEditar.id;
      this.tipoDocumentoTransporte = this.documentoEditar.tipo.nombre;
      this.tipo_documento = this.documentoEditar.tipo.id;

      this.fecha_recepcion = moment(this.documentoEditar.fecha_recepcion)
        .format("YYYY-MM-DD")
        .toString();

      const tipo_id = this.tipo_documento;

      switch (tipo_id) {
        case 1:
          this.tipo_transporte = this.documentoEditar.base.tipo_transporte;
          this.numero_documento = this.documentoEditar.base.numero_documento;
          break;
        case 2:
          this.tipo_vistos_buenos =
            this.documentoEditar.base.tipo_vistos_buenos;
          this.vb_n_solicitud = this.documentoEditar.numero_solicitud;
          this.estado = this.documentoEditar.base.estado;
          break;
        case 3:
          this.statusBl = this.documentoEditar.base.status;
          break;
        case 4: // DIN
          this.fecha_aceptacion = moment(
            this.documentoEditar.base.fecha_aceptacion
          )
            .format("YYYY-MM-DD")
            .toString();
          if (
            this.tipo_inspeccion_aforo != undefined ||
            this.tipo_inspeccion_aforo.trim() != ""
          ) {
            this.tipo_inspeccion_aforo =
              this.documentoEditar?.base?.tipo_inspeccion_id;
          }
          break;
        case 10:
          this.numero_guia_despacho =
            this.documentoEditar.base.numero_guia_despacho;
          break;
        case 17:
          this.fecha_presentacion_primer_dus =
            this.documentoEditar.base.fecha_presentacion;
          this.hora_presentacion_primer_dus =
            this.documentoEditar.base.hora_presentacion;
          this.numero_primer_dus = this.documentoEditar.base.numero_dus;
          this.orden_alerta = this.documentoEditar.base.orden_alerta;
          break;
        case 18:
          this.fecha_dus_legalizado =
            this.documentoEditar.base.fecha_dus_legalizado;
          break;
        case 20:
          this.nombre_documento = this.documentoEditar.base.nombre_documento;
          break;
        case 30: // Comprobante seleccion aforo
          if (
            this.tipo_inspeccion_aforo != undefined ||
            this.tipo_inspeccion_aforo.trim() != ""
          ) {
            this.tipo_inspeccion_aforo =
              this.documentoEditar?.base?.tipo_inspeccion_id;
          }
          break;
        case 35:
          this.numero_solicitud = this.documentoEditar.numero_solicitud;
          this.estado = this.documentoEditar.base.estado;
          break;
      }
    },
    changeTipoDocumentoTransporte(nuevoTipoDocumentoTransporte) {
      if (nuevoTipoDocumentoTransporte == 1) this.tipoDocumentoBl = true;
      else this.tipoDocumentoBl = false;
    },
    async eliminar(file) {
      let variable = await this.$swal({
        title: "¿Deseas eliminar este documento?",
        text: "¿Está seguro? ¡No podrás revertir esta acción!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Borrar!",
        cancelButtonText: "No, cancelar!",
        buttonsStyling: true,
      });
      if (variable.isConfirmed == true) {
        if (file.id) {
          this.files_delete.push(file.id);
        }

        let encontro = false;
        this.files = this.files.filter((el) => {
          if (file.id) {
            if (el.id) {
              if (file.id != el.id) {
                return el;
              }
            }
          }
          if (!encontro) {
            if (el.name == file.name) {
              encontro = true;
            } else {
              return el;
            }
          } else {
            return el;
          }
        });
      }
    },
    async fetchTiposInspeccion() {
      this.isFetching = true;
      try {
        const query = {
          params: {
            get: '["tipos_inspeccion"]',
          },
        };
        const { data } = await axios.get(`/api/list`, query);

        if (data?.data?.tipos_inspeccion) {
          this.tipos_inspeccion_aforo = [...data.data.tipos_inspeccion];
        }
        this.isFetching = false;
        this.isError = false;
      } catch (e) {
        this.isFetching = false;
        this.isError = true;
        console.error(e);
        this.errors.push(
          "Hubo un error al obtener los tipos de inspección de aforo"
        );
      }
    },
    async submit() {
      let formData = new FormData();

      this.id = this.$route.params.despachoId;
      formData.append("despachos_id", this.id);
      formData.append("fecha_recepcion", this.fecha_recepcion);

      for (var i = 0; i < this.files_delete.length; i++) {
        formData.append("delete_files[" + i + "]", this.files_delete[i]);
      }
      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i];
        if (!this.files[i].id) formData.append("files[" + i + "]", file);
      }

      switch (this.documentoEditar.tipo_documentos_id) {
        case 1:
          formData.append("tipo_transporte", this.tipo_transporte);
          formData.append("numero_documento", this.numero_documento);
          break;

        case 2:
          formData.append("tipo_vistos_buenos", this.tipo_vistos_buenos);
          formData.append("numero_solicitud", this.vb_n_solicitud);
          formData.append("estado", this.estado);
          break;

        case 3:
          formData.append("status", this.statusBl);
          break;

        case 4: // DIN
          formData.append("fecha_aceptacion", this.fecha_aceptacion);
          formData.append("tipo_inspeccion_aforo", this.tipo_inspeccion_aforo);
          break;

        case 10:
          formData.append("numero_guia_despacho", this.numero_guia_despacho);
          break;

        case 17:
          formData.append(
            "fecha_presentacion",
            this.fecha_presentacion_primer_dus
          );
          formData.append(
            "hora_presentacion",
            this.hora_presentacion_primer_dus
          );
          formData.append("numero_dus", this.numero_primer_dus);
          formData.append("orden_alerta", this.orden_alerta);
          break;

        case 18:
          formData.append("fecha_dus_legalizado", this.fecha_dus_legalizado);
          break;
        case 20:
          formData.append("nombre_documento", this.nombre_documento);
          break;
        case 30: // Comprobante seleccion aforo
          formData.append("tipo_inspeccion_aforo", this.tipo_inspeccion_aforo);
          break;
        case 35:
          formData.append("numero_solicitud", this.numero_solicitud);
          formData.append("estado", this.estado);
          break;
      }

      formData.append("_method", "put");

      if (this.files.length > 0) {
        this.cancelar();
        this.postDocumento(this.idDocumento, formData);
        this.tipo_documento = "";
        this.tipoDocumentoTransporte = "";
        this.fecha_recepcion = "";
        this.files = [];
      } else {
        this.$swal({
          icon: "warning",
          title: "",
          text: "Se deben subir documentos para su comprobación",
        });
      }
    },
  },
};
</script>

<template>
  <form
    @submit.prevent="submit"
    id="form-documentos"
    enctype="multipart/form-data"
    class="flex flex-col text-left gap-8 pb-[2%]"
  >
    <div class="flex flex-row gap-2 text-xl">
      Tipo de documento -
      <strong>{{ documentoEditar.tipo.nombre ?? "-" }}</strong>
    </div>

    <div class="grid sm:grid-cols-2 gap-12">
      <div class="flex flex-col gap-4">
        <div>
          <label>Adjuntar documento</label>
          <b-form-file
            browse-text="Buscar"
            placeholder="Seleccione un archivo"
            drop-placeholder="Coloque el archivo aquí..."
            v-model="file"
            ref="file-input"
            multiple
          ></b-form-file>
        </div>

        <div class="flex flex-row gap-4 items-center">
          <button
            class="w-12 hover:scale-110 transition-all"
            v-b-tooltip.hover
            :title="file.name"
            type="button"
            v-for="(file, index) in files"
            :key="index"
            @click="eliminar(file)"
          >
            <inline-svg
              class="size-12"
              v-if="file.name.split('.').at(-1) == 'pdf'"
              src="../../assets/images/archivo-pdf.svg"
            />
            <inline-svg
              class="size-12"
              v-if="
                file.name.split('.').at(-1) == 'png' ||
                file.name.split('.').at(-1) == 'jpg' ||
                file.name.split('.').at(-1) == 'jpeg'
              "
              src="../../assets/images/archivo-png.svg"
            />
          </button>
        </div>
      </div>
      <div class="w-80">
        <label>Fecha de recepción</label>
        <input type="date" v-model="fecha_recepcion" />
      </div>
    </div>

    <!---->

    <div class="flex flex-col gap-4">
      <div
        v-if="tipoDocumentoTransporte == 'Documento de Transporte'"
        class="grid grid-cols-2 sm:grid-cols-3 gap-12"
      >
        <div>
          <label> Tipo de documento DE TRANSPORTE</label>
          <select
            id="docuento-select"
            v-model="tipo_transporte"
            @change="changeTipoDocumentoTransporte(tipo_transporte)"
          >
            <option value="0">
              Seleccione el Tipo de documento de transporte
            </option>
            <option
              v-for="(tipoDocTrans, index) in documentos.documento_transporte"
              :key="index"
              :value="tipoDocTrans"
            >
              {{ tipoDocTrans }}
            </option>
          </select>
        </div>
        <div>
          <label> Numero Documento de Transporte </label>
          <input v-model="numero_documento" />
        </div>
      </div>

      <!---->
      <div
        v-if="tipoDocumentoTransporte == 'Guía de Despacho'"
        class="grid grid-cols-2 sm:grid-cols-3 gap-12"
      >
        <div>
          <label> Número Guía Despacho </label>
          <input v-model="numero_guia_despacho" />
        </div>
      </div>

      <!---->

      <div
        v-if="tipoDocumentoTransporte == 'Visto Bueno (CDA)'"
        class="grid grid-cols-2 sm:grid-cols-3 gap-12"
      >
        <div>
          <label>Tipo de VB</label>
          <select id="docuento-select" v-model="tipo_vistos_buenos">
            <option value="0">Selecciona un tipo de vistos buenos</option>
            <option
              v-for="(tipo, index) in documentos.tipos_vistos_buenos"
              :key="index"
              :value="tipo"
            >
              {{ tipo }}
            </option>
          </select>
        </div>
        <div>
          <label>N° Solicitud</label>
          <input v-model="vb_n_solicitud" />
        </div>

        <div>
          <label>Estado VB</label>

          <select v-model="estado">
            <option selected value="Pendiente">Pendiente</option>
            <option value="Aprobado">Aprobado</option>
            <option value="Inmovilizado">Inmovilizado</option>
            <option value="Pendiente de Inspección">
              Pendiente de Inspección
            </option>
            <option value="Presentado">Presentado</option>
            <option value="Rechazado">Rechazado</option>
          </select>
        </div>
      </div>

      <!---->

      <div
        v-if="tipoDocumentoTransporte == 'DIN'"
        class="grid grid-cols-2 sm:grid-cols-3 gap-12"
      >
        <div>
          <label> Fecha Aceptación </label>
          <input type="date" v-model="fecha_aceptacion" />
        </div>
        <div>
          <label>Tipo de inspección de aforo</label>
          <select v-model="tipo_inspeccion_aforo">
            <option selected value="">Sin aforo</option>
            <option
              v-for="(tipo, i) in tipos_inspeccion_aforo"
              :key="i"
              :value="tipo.value"
            >
              {{ tipo.key }}
            </option>
          </select>
        </div>
      </div>

      <div
        v-if="tipoDocumentoTransporte == 'BL Corregido'"
        class="grid grid-cols-2 sm:grid-cols-3 gap-12"
      >
        <div>
          <label> Status BL </label>
          <select id="status-select" v-model="statusBl">
            <option value="0">Selecciona el status del BL</option>
            <option
              v-for="(tipo, index) in documentos.bl.status"
              :key="index"
              :value="tipo"
            >
              {{ tipo }}
            </option>
          </select>
        </div>
      </div>

      <!---->

      <div
        v-if="tipoDocumentoTransporte == '1ER DUS'"
        class="grid grid-cols-2 sm:grid-cols-3 gap-12"
      >
        <div>
          <label> Fecha Presentación </label>
          <b-form-datepicker
            label-next-month="Siguiente mes"
            label-next-year="Siguiente año"
            label-current-month="Mes actual"
            label-prev-year="Año anterior"
            label-prev-month="Mes anterior"
            label-prev-decade="Decada anterior"
            label-next-decade="Decada siguiente"
            label-no-date-selected="No hay fecha seleccionada"
            label-help="Usa el cursos para navegar por las fechas"
            v-model="fecha_presentacion_primer_dus"
          ></b-form-datepicker>
        </div>
        <div>
          <label> Hora de Retiro </label>
          <b-form-timepicker
            label-no-time-selected="No hay hora seleccionada"
            label-close-button="Cerrar"
            label-hours="Horas"
            label-minutes="Minutes"
            v-model="hora_presentacion_primer_dus"
            locale="es"
          ></b-form-timepicker>
        </div>
        <div>
          <label> Número Primer Dus </label>
          <input type="text" v-model="numero_primer_dus" required />
        </div>
        <div>
          <label> Cantidad de días para alerta </label>
          <input type="text" v-model="orden_alerta" required />
        </div>
      </div>

      <!---->

      <div
        v-if="tipoDocumentoTransporte == 'DUS LEGALIZADO'"
        class="grid grid-cols-2 sm:grid-cols-3 gap-12"
      >
        <div>
          <label> Fecha Dus Legalizado </label>
          <b-form-datepicker
            label-next-month="Siguiente mes"
            label-next-year="Siguiente año"
            label-current-month="Mes actual"
            label-prev-year="Año anterior"
            label-prev-month="Mes anterior"
            label-prev-decade="Decada anterior"
            label-next-decade="Decada siguiente"
            label-no-date-selected="No hay fecha seleccionada"
            label-help="Usa el cursor para navegar por las fechas"
            v-model="fecha_dus_legalizado"
          ></b-form-datepicker>
        </div>
      </div>

      <!---->

      <div
        v-if="tipoDocumentoTransporte == 'Otro'"
        class="grid grid-cols-2 sm:grid-cols-3 gap-12"
      >
        <div>
          <label>Nombre de documento</label>
          <input type="text" v-model="nombre_documento" />
        </div>
      </div>

      <!---->

      <!-- USO Y DISPOSCIION ------>
      <div
        v-if="tipo_documento == 35"
        class="grid grid-cols-2 sm:grid-cols-3 gap-12"
      >
        <div>
          <label>N° Solicitud</label>
          <input v-model="numero_solicitud" />
        </div>

        <div>
          <label>Estado </label>

          <select v-model="estado">
            <option value="Pendiente">Pendiente</option>
            <option value="Aprobado">Aprobado</option>
            <option value="Inmovilizado">Inmovilizado</option>
            <option value="Pendiente de Inspección">
              Pendiente de Inspección
            </option>
            <option value="Presentado">Presentado</option>
            <option value="Rechazado">Rechazado</option>
          </select>
        </div>
      </div>

      <!---- Comprobante seleccion aforo -->
      <div
        v-if="tipo_documento == 30"
        class="grid grid-cols-2 sm:grid-cols-3 gap-12"
      >
        <div>
          <label>Tipo de inspección de aforo</label>
          <select v-model="tipo_inspeccion_aforo">
            <option selected value="">Sin aforo</option>
            <option
              v-for="(tipo, i) in tipos_inspeccion_aforo"
              :key="i"
              :value="tipo.value"
              :selected="tipo.value == tipo_inspeccion_aforo"
            >
              {{ tipo.key }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="md:col-span-4 flex flex-row items-center gap-2 justify-end">
      <button class="btn-principal" type="submit">Enviar</button>
      <slot name="cancelar"></slot>
    </div>
  </form>
</template>
